// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__MQKdq","label":"TextArea_label__FpAZp","textarea":"TextArea_textarea__CSqMe","readOnly":"TextArea_readOnly__7UrIv"};